import { cn } from "@newxsystems/shared";
import { WohaAction } from "../WohaAction/WohaAction";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";
const layouts = {
  small: { image: "md:col-span-4 md:col-start-9", text: "md:col-span-8" },
  medium: { image: "md:col-span-5 md:col-start-8", text: "md:col-span-7" },
  large: { image: "md:col-span-6 md:col-start-7", text: "md:col-span-6" },
} as const;
export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => {
  const layout = layouts[imageWidth || "medium"];

  return (
    <div
      className={cn(
        "grid grid-cols-1 items-center gap-6 md:gap-12",
        image ? "md:grid-cols-12" : buttons?.length && "md:grid-cols-2",
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "order-1 text-sm font-medium text-white/80 md:col-start-1",
            image && layout.text,
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {image ? (
        <WohaMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn(
            "order-2 w-full justify-self-end border-4 border-white/20 md:row-span-4 md:row-start-1",
            layout.image,
          )}
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2
          className={cn(
            "order-3 font-satoshi text-4xl font-medium leading-[1.05] tracking-[-0.02em] text-white text-balance md:col-start-1 md:text-5xl",
            image && layout.text,
          )}
        >
          {heading}
        </h2>
      ) : null}
      {description ? (
        <WohaRichText
          className={cn(
            "order-4 max-w-[65ch] text-base leading-7 text-white/80 md:col-start-1",
            image && layout.text,
          )}
          content={description}
        />
      ) : null}
      {buttons?.length ? (
        <div
          className={cn(
            "order-5 flex flex-wrap gap-3",
            image
              ? cn("md:col-start-1", layout.text)
              : "md:col-start-2 md:row-span-3 md:row-start-1 md:justify-self-end",
          )}
        >
          {buttons.map((button, index) => (
            <WohaAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
CallToActionSplit.displayName = "Content::CallToActionSplit";
